import React from 'react';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import WhoItsForSection from './components/WhoItsForSection';
import BenefitsSection from './components/BenefitsSection';
import FeaturesSection from './components/FeaturesSection';
import WhyDifferentSection from './components/WhyDifferentSection';
import PricingSection from './components/PricingSection';
import TrustSection from './components/TrustSection';
import MobileAppSection from './components/MobileAppSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const LandingPage = () => {
  return (
    <>
      <Helmet>
        <title>Rovyn Budget - Simple, Smart Financial Management</title>
        <meta 
          name="description" 
          content="Control and understand your money with Rovyn Budget. Track income, expenses, and balances across all accounts. Mobile-first budgeting platform with powerful insights. Start free today." 
        />
        <meta name="keywords" content="budget app, money management, expense tracking, financial insights, personal finance, budgeting tool, mobile budget app" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <HeroSection />
        <WhoItsForSection />
        <BenefitsSection />
        <FeaturesSection />
        <WhyDifferentSection />
        <PricingSection />
        <TrustSection />
        <MobileAppSection />
        <CTASection />
        <Footer />
      </div>
    </>
  );
};

export default LandingPage;